import React from "react";
import { Link } from "react-router-dom";
import "../MenuLeftPhoneProvComercializador/menuLeftPhone.css";
//
import logo from "../../../assets/logo/logo2.png";
//
import { MdOutlineAttachMoney } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import { FaUserCog } from "react-icons/fa";
import { FaFileArchive } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import { LuClipboardList } from "react-icons/lu";
import { ImProfile } from "react-icons/im";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuPhoneAdmin = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="boxphonemenucel">
      <div>
        <div className="boxlogophonemenu">
          <img src={logo} alt="logo" />
        </div>
        <div className="flexbuttonsphone">
          <div className="buttonsphone">
            <Link to="/portal-admin-proveedor/todas-las-ventas">
              <p className="textcel">
                <MdOutlineAttachMoney className="phoneicon" />
                Ventas
              </p>
            </Link>
          </div>
          <div className="buttonsphone">
            <Link to="/portal-admin-proveedor/lista-comercializadores">
              <p className="textcel">
                <FaUserCog className="phoneicon" />
                Comercializador
              </p>
            </Link>
          </div>
          <div className="buttonsphone">
            <Link to="/portal-admin-proveedor/lista-proveedores">
              <p className="textcel">
                <FaUserCog className="phoneicon" />
                Proveedores
              </p>
            </Link>
          </div>
        </div>
        <div className="flexbuttonsphone">
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "Perfil")}
          >
            <p className="textcel">
              <FaUserAlt className="phoneicon" />
              Perfil
            </p>
          </div>
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "Excel")}
          >
            <p className="textcel">
              <ImProfile className="phoneicon" />
              Alta Comercializadores
            </p>
          </div>
        </div>
        <div className="flexbuttonsphone">
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "ExcelSales")}
          >
            <p className="textcel">
              <FaFileArchive className="phoneicon" />
              Alta de ventas
            </p>
          </div>
          <div
            className="buttonsphone"
            onClick={(e) => changeviewprov(e, "ListProveedordescarga")}
          >
            <p className="textcel">
              <LuClipboardList className="phoneicon" />
              Descargar ventas
            </p>
          </div>
        </div>
        <div className="flexbuttonsphone">
          <div
            className="buttonsphone "
            onClick={(e) => changeviewprov(e, "Contraseña")}
          >
            <p className="textcel">
              <RiLockPasswordFill className="phoneicon" />
              Cambiar contraseña
            </p>
          </div>
          <div className="buttonsphone " onClick={handleLogout}>
            <p className="textcel">
              <FaDeleteLeft className="phoneicon" />
              Salir
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPhoneAdmin;
